<template>
  <el-dialog title="答卷详情" top="30vh" custom-class="ui-box-dialog" :visible.sync="dialogVisible" width="800px" :before-close="dialogBeforeClose">
    <div v-for="(item,index) in detailsVo" :key="index" style="margin-bottom:20px">
      <template v-if="[1,2,3].includes(item.tbType)">
        <div style="margin-bottom:5px">{{`${item.tbSort}、${item.tbQuestionnaireName}  (${typeMap[item.tbType]})`}}</div>
        <pie :item="item"></pie>
        <div class="tableList">
          <el-table :data="item.answers" border :max-height="400" style="width: 100%" :header-cell-style="{background: '#F2F6FC',color: '#000000','font-weight': 500,'font-family': 'Microsoft YaHei'}">
            <el-table-column align="center" prop="tbOptionsContent" label="选项" show-overflow-tooltip>
              <template slot-scope="{ row,  $index }">
                <div :style="{'margin-right':'3px','display':'inline-block','line-height':'23px',width:'10px',height:'10px',background:color[$index],'border-radius':'50%'}"></div>
                <span>{{row.tbOptionsContent}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="percentage" label="占比">
              <template slot-scope="{row}">
                <div style="">{{row.percentage+'%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="choiceNumber" label="数量">
            </el-table-column>
          </el-table>
        </div>
      </template>
      <el-collapse v-else v-model="item.activeName" @change="handleChange" :accordion="true">
        <el-collapse-item :title="`${item.tbSort}、${item.tbQuestionnaireName}  (${typeMap[item.tbType]})`" :name="item.tbSort">
          <el-table :data="item.list" border :max-height="600" style="width: 100%" :header-cell-style="{background: '#F2F6FC',color: '#000000','font-weight': 500,'font-family': 'Microsoft YaHei'}">
            <el-table-column align="center" type="index" width="68px" label="序号">
            </el-table-column>
            <el-table-column align="center" prop="nickname" label="姓名">
            </el-table-column>
            <el-table-column align="center" prop="createTime" label="答题时间">
            </el-table-column>
            <el-table-column align="center" prop="tbAnswerContent" label="答案" show-overflow-tooltip>
            </el-table-column>
          </el-table>
          <pagination class="ui-papagination" @size-change="page.pagingSizeChange" @current-change="page.pagingCurrentChange" :total="page.total" :pageSizes="page.pageSizes" :pageSize="page.pageSize" :currentPage="page.currentPage"></pagination>
        </el-collapse-item>
      </el-collapse>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="ui-box-cancel" @click="dialogBeforeClose">取 消</el-button>
      <el-button class="ui-box-submit" type="primary" @click="dialogBeforeClose">确 认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import pie from '@/components/audit/questionnaire/pie.vue'
export default {
  name: 'statisticDialog',
  props: {
    detailsVo: {
      type: Array,
      default: function () {
        return []
      }
    },
    dialogVisible: {
      type: Boolean
    }
  },
  data () {
    const _this = this
    return {
      page: {
        currentPage: 1, //当前页
        pageSize: 10, //每页记录数
        total: 10,
        pageSizes: [10, 20, 50, 100],
        pagingSizeChange (value) {
          _this.page.currentPage = 1
          _this.page.pageSize = value
          _this.queryBriefAnswerList()
        },
        pagingCurrentChange (value) {
          _this.page.currentPage = value
          _this.queryBriefAnswerList()
        }
      },
      index: '',
      color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
      option: {
        tooltip: {
          show: false
        },
        legend: {
          orient: 'vertical',
          left: 'right',
          top: 'middle',
          icon: 'rect',
          itemHeight: 14,
          itemWidth: 14,
          align: 'left',
          formatter: function (json) {
            const { sort, percentage } = JSON.parse(json)
            return `${sort}: ${percentage}`
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '50%',
            data: [],
            label: {
              show: false
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      typeMap: {
        1: '单选题',
        2: '多选题',
        3: '判断题',
        5: '简答题'
      }
    }
  },
  watch: {

  },
  components: {
    pie
  },
  computed: {

  },
  methods: {
    queryBriefAnswerList () {
      const seach = {
        tbQuestionnaireId: this.detailsVo[this.index].tbId
      }
      seach.page = this.page.currentPage
      seach.size = this.page.pageSize
      this.$http.get(`questionnaireSet/queryBriefAnswerList`, seach)
        .then(res => {
          if (res.code === 1000) {
            this.detailsVo[this.index].list = res.data.list
            this.page.total = res.data.total
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handleChange (item, index) {
      if (item) {
        this.page.currentPage = 1
        this.page.pageSize = 10
        this.index = this.detailsVo.findIndex(i => i.tbSort === item)
        this.queryBriefAnswerList()
      }
    },
    dialogBeforeClose () {
      this.$emit('update:dialogVisible', false)
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ui-box-dialog {
  border-radius: 12px;
  ::v-deep .el-dialog__title {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 500;
    color: #333333;
    line-height: 16px;
  }
  ::v-deep .el-dialog__headerbtn {
    &:focus {
      outline: none;
    }
  }
  ::v-deep .el-dialog__body {
    height: 600px;
    overflow-y: auto;
  }
  ::v-deep .el-collapse {
    border: none;
    ::v-deep .el-collapse-item__header {
      border: none;
    }
    ::v-deep .el-collapse-item__wrap {
      border: none;
    }
  }
  .tableList {
    vertical-align: top;
    display: inline-block;
    width: 400px;
  }
  .ui-box-cancel {
    padding: 7px 26px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #555555;
    line-height: 22px;
    &:focus {
      outline: none;
    }
  }
  .ui-box-submit {
    padding: 7px 26px;
    background: #3d7fff;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 22px;
    &:focus {
      outline: none;
    }
  }
}

::v-deep .ui-box-dialog {
  border-radius: 12px;
  .el-dialog__title {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 500;
    color: #333333;
    line-height: 16px;
  }
  .el-dialog__body {
    height: 600px;
    overflow-y: auto;
  }
  .el-dialog__headerbtn {
    &:focus {
      outline: none;
    }
  }
  .el-collapse {
    border: none;
    .el-collapse-item__header {
      border: none;
    }
    .el-collapse-item__wrap {
      border: none;
    }
  }
  .ui-box-cancel {
    padding: 7px 26px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #555555;
    line-height: 22px;
    &:focus {
      outline: none;
    }
  }
  .ui-box-submit {
    padding: 7px 26px;
    background: #3d7fff;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 22px;
    &:focus {
      outline: none;
    }
  }
}
</style>